import React, { useEffect, useState } from 'react';
import {
  TextField,
  MenuItem,
  Button,
  Typography,
  
  Paper,
  
  FormControl,
  InputLabel,
  Select,
  Box,
  CircularProgress
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  createEmployee,
  updateEmployee
} from '../../redux/actions/employee/employeeAction';
import { fetchDepartments } from '../../redux/actions/department/departmentAction';
import { toast } from 'react-toastify';

const statuses = ['Active', 'Inactive'];

const EmployeeForm = ({ selectedEmployee, onReset }) => {
  const dispatch = useDispatch();
  const departments = useSelector((state) => state.department.departments);
  const { createLoading, updateLoading } = useSelector((state) => state.employee);

  const [formData, setFormData] = useState({
    emp_code: '',
    name: '',
    department_id: '',
    status: 'Active'
  });

  useEffect(() => {
    dispatch(fetchDepartments());
  }, [dispatch]);

  useEffect(() => {
    if (selectedEmployee) {
      setFormData(selectedEmployee);
    } else {
      setFormData({
       emp_code: '',
    name: '',
    department_id: '',
    status: 'Active'
      });
    }
  }, [selectedEmployee]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (selectedEmployee) {
        await dispatch(updateEmployee(selectedEmployee.id, formData));
        toast.success('Employee updated successfully');
      } else {
        await dispatch(createEmployee(formData));
        toast.success('Employee created successfully');
      }
      setFormData({
       emp_code: '',
    name: '',
    department_id: '',
    status: 'Active'
      });
      if (onReset) onReset();
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.message || 'An error occurred while processing employee';
      toast.error(errorMessage);
    }
  };

  const handleClear = () => {
    setFormData({
      emp_code: '',
      name: '',
      department_id: '',
      status: 'Active'
    });
    if (onReset) onReset();
  };

  const isLoading = createLoading || updateLoading;

  return (
    <Paper
      elevation={3}
      sx={{p: 3, boxShadow: 'none', background: 'transparent'}}>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        {selectedEmployee ? 'Edit Employee' : 'Add Employee'}
      </Typography>

    <form onSubmit={handleSubmit}>
      <TextField
              fullWidth
              name="emp_code"
              label="Employee Code"
              value={formData.emp_code}
              onChange={handleChange}
              margin="normal"
              required
              autoComplete="off"
              disabled={isLoading}
            />
         
          
            <TextField
              fullWidth
              name="name"
              label="Name"
              value={formData.name}
              onChange={handleChange}
              margin="normal"
              required
              autoComplete="off"
              disabled={isLoading}
            />
         
            <FormControl fullWidth margin="normal">
              <InputLabel>Department</InputLabel>
              <Select
                name="department_id"
                value={formData.department_id}
                onChange={handleChange}
                disabled={isLoading}
              >
                {departments.map((dept) => (
                  <MenuItem key={dept.id} value={dept.id}>
                    {dept.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
         
            <FormControl fullWidth margin="normal">
              <InputLabel>Status</InputLabel>
              <Select
                name="status"
                value={formData.status}
                onChange={handleChange}
                disabled={isLoading}
              >
                {statuses.map((status) => (
                  <MenuItem key={status} value={status}>
                    {status}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          
            <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
              <Button 
                type="submit" 
                variant="contained" 
                color="primary" 
                fullWidth
                disabled={isLoading}
                startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : null}
              >
                {isLoading ? 'Processing...' : (selectedEmployee ? 'Update' : 'Add')}
              </Button>
              <Button 
                type="button" 
                variant="outlined" 
                color="primary" 
                fullWidth
                onClick={handleClear}
                disabled={isLoading}
              >
                Clear
              </Button>
            </Box>
          
      </form>
    </Paper>
  );
};

export default EmployeeForm;
